module.exports = __webpack_public_path__ + "static/media/pino_odense.b9aab38c.jpg";